import { Component, OnInit, OnDestroy } from '@angular/core';
import { DynReportService, DynamicReportType } from '../shared';

@Component({
  selector: 'bp-dyn-report-list',
  templateUrl: './dyn-report-list.component.html'
})

export class DynReportListComponent implements OnInit, OnDestroy {


  reportTypes: DynamicReportType[] = null;

  constructor(
    private dynReportService: DynReportService
  ) { }

  ngOnInit() {
    this.getReportTypes();

  }

  ngOnDestroy(): void {

  }
  getReportTypes() {
    

    this.dynReportService.getReportsTypes()
      .subscribe(reportTypes => {
        this.reportTypes = [];
        this.reportTypes = reportTypes;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-report-list/dyn-report-list.component.ts